"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _v = _interopRequireDefault(require("./merchant-dashboard/v0"));

var _v2 = _interopRequireDefault(require("./merchant-dashboard/v1"));

var _v3 = _interopRequireDefault(require("./merchant-dashboard/v2"));

var _v4 = _interopRequireDefault(require("./merchant-dashboard/v3"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'MerchantDashboard',
  components: {
    V0: _v.default,
    V1: _v2.default,
    V2: _v3.default,
    V3: _v4.default
  },
  data: function data() {
    return {
      data: {},
      loading: true,
      labels: [],
      values: [],
      url: 'https://www.showdoc.com.cn/PayCenterAPI/',
      httpAPI: null,
      smppAPI: null,
      numberOfDecimal: 2
    };
  },
  created: function created() {
    var _this = this;

    _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
      _this.numberOfDecimal = res.data.numberOfDecimal;
    }).catch(function (err) {
      _this.$message({
        message: err.message,
        type: 'error'
      });
    });

    _httpUtils.default.get("HomeData", "getMerchantIndex").then(function (res) {
      _this.data = (0, _objectSpread2.default)({}, res.data);
      _this.loading = false;
    });

    _httpUtils.default.get("HomeData", "getLastFiveDataOfOrganizations").then(function (res) {
      var labels = [];
      var values = [];
      res.data.forEach(function (data) {
        labels.push(data.statisticalDate);
        values.push(data.increaseAmount);
      });
      _this.labels = labels.reverse();
      _this.values = values.reverse();
      var labelLength = _this.labels.length;
      if (!labelLength) return;

      if (labelLength < 5) {
        for (var i = 0; i < 5 - labelLength; i++) {
          _this.labels.push('-');

          _this.values.push(0);
        }
      }

      if (_this.values.filter(function (v) {
        return v !== 0;
      }).length) {
        _this.$nextTick(function () {
          return _this.$refs.dashboard.$refs.barChart.initChart();
        });
      }
    }); // httpUtils.get("homeDataInMerchant", "getHTTPAPIDocPath").then((res) => {
    //   if(res !== null){
    //     this.url = res;
    //   }
    // });
    // httpUtils.get("homeDataInMerchant", "getHTTPAPI").then((res) => {
    //   if(res !== null){
    //     this.httpAPI = res;
    //   }
    // });
    // httpUtils.get("homeDataInMerchant", "getSMPPAPI").then((res) => {
    //   if(res !== null){
    //     this.smppAPI = res;
    //   }
    // });

  },
  computed: {
    currentVersion: function currentVersion() {
      return "V".concat(this.$store.getters.platform);
    },
    approvalStatus: function approvalStatus() {
      // For styling approval status components
      if (this.data.org) {
        var approvalStatus;
        var approvalType;

        switch (this.data.org.approveStateCode) {
          case '1':
            approvalStatus = this.$t('dashboard.merchant.unsuccessful');
            approvalType = 'warning';
            break;

          case '2':
            approvalStatus = this.$t('dashboard.merchant.approved');
            approvalType = 'success';
            break;

          case '3':
            approvalStatus = this.$t('dashboard.merchant.notApproved');
            approvalType = 'danger';
            break;

          default:
            break;
        }

        return {
          approvalStatus: approvalStatus,
          approvalType: approvalType
        };
      } else {
        return {};
      }
    },
    orgStatus: function orgStatus() {
      // For styling organization status components
      if (this.data) {
        var orgStatus = this.$t('dashboard.merchant.blocked');
        var orgType = 'danger';

        if (this.data.status === "1") {
          orgStatus = this.$t('dashboard.merchant.normal');
          orgType = 'success';
        }

        return {
          orgStatus: orgStatus,
          orgType: orgType
        };
      } else {
        return {};
      }
    },
    tableData: function tableData() {
      // Computed Properties to show data in table form
      var orgStatus = this.$t('dashboard.merchant.blocked');
      var orgType = 'danger';
      if (this.loading) return;

      if (this.data.status === "1") {
        orgStatus = this.$t('dashboard.merchant.normal');
        orgType = 'success';
      } // let approvalStatus;
      // let approvalType;
      // switch (this.data.org.approveStateCode) {
      //   case '1':
      //     approvalStatus = this.$t('dashboard.merchant.unsuccessful');
      //     approvalType = 'warning'
      //     break;
      //   case '2':
      //     approvalStatus = this.$t('dashboard.merchant.approved');
      //     approvalType = 'success'
      //     break;
      //   case '3':
      //     approvalStatus = this.$t('dashboard.merchant.notApproved');
      //     approvalType = 'danger'
      //     break;
      //   default:
      //     break
      // }


      return [{
        label: this.$t('dashboard.merchant.organizationName'),
        value: this.data.organizationName
      }, {
        label: this.$t('dashboard.merchant.organizationStatus'),
        value: orgStatus,
        tag: 'orgStatus',
        type: orgType
      }, // {
      //   label: this.$t('dashboard.merchant.approvalStatus'),
      //   value: approvalStatus,
      //   tag: 'approvalStatus',
      //   type: approvalType
      // },
      {
        label: this.$t('dashboard.merchant.organizationCode'),
        value: this.data.organizationCode
      }, {
        label: this.$t('dashboard.merchant.md5Key'),
        value: this.data.MD5Key
      }, // {
      //   label: this.$t('dashboard.merchant.accessNumber'),
      //   value: this.data.property.systemId,
      // },
      // {
      //   label: this.$t('dashboard.merchant.accessCode'),
      //   value: this.data.property.password,
      // },
      // {
      //   label: this.$t('dashboard.merchant.numberOfConnections'),
      //   value: this.data.property.channelLine,
      // },
      // {
      //   label: this.$t('dashboard.merchant.channelRate'),
      //   value: this.data.property.channelLimit,
      // },
      {
        label: this.$t('dashboard.merchant.goToDocs'),
        value: this.url,
        button: true
      }];
    }
  },
  methods: {
    redirectToDocs: function redirectToDocs() {
      window.open(this.url, '_blank');
    }
  }
};
exports.default = _default;